import { Card, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { StatusPill } from "./StatusPill";

export function ClipboardScoreImpactCard() {
  return (
    <Card variant="tertiary" sx={(theme) => ({ padding: theme.spacing(5) })}>
      <Stack spacing={3}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Text semibold variant="body1">
            Clipboard Score
          </Text>
          <StatusPill label="Not Affected" variant="success" />
        </Stack>
        <Text variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
          Workplace cancellations do not affect your Clipboard Score.
        </Text>
      </Stack>
    </Card>
  );
}
